import {ValueObject} from '@s-ui/domain'

export class NewsCommentsRequestValueObject extends ValueObject {
  /**
   * @param {Object} params
   * @param {String} params.articleId
   * @param {Number} params.items
   * @param {Number} params.pageNumber
   */
}
